import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/seller-net-proceeds-calculator',
  component: () => import('../../routes/SellerNetProceeds.svelte'),
  card: {
    id: 'seller-net-proceeds',
    title: "Seller's Net Proceeds",
    description: 'Calculate how much money you will take home after selling your house, minus agent commissions and closing costs.',
    icon: 'savings',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/seller-net-proceeds-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: "Seller's Net Proceeds Calculator – How Much Will You Make Selling Your Home?",
    description: "Free seller's net proceeds calculator. Calculate your actual take-home amount after real estate agent commissions, closing costs, mortgage payoff, and seller concessions.",
  },
};

export default meta;
